import angular from 'angular';
import { ApiService } from '@b2b/common/services/api/types';
import { FetchPartnerFormsProps } from './partners-detail.types';

export class PartnersDetailService {
  static $inject = ['ApiService'];

  constructor(private apiService: ApiService) {}

  fetchPartnerForms(props: FetchPartnerFormsProps) {
    return this.apiService.orders.forms.responses.organization.list(
      { organizationId: props.organizationId },
      {
        page: props.page,
        pageSize: props.pageSize,
        sortDirection: props.sortDirection,
        sortField: props.sortField,
        filterType: props.filterType,
        startDate: props.startDate,
        endDate: props.endDate,
      },
    );
  }
}

export const PartnersDetailServiceModule = angular
  .module('acme.view.application.partners.detail.service', ['acme.common.service.api'])
  .service('PartnersDetailService', PartnersDetailService).name;
